/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// utils
// material
import { Button } from '@insticator/insticator-ui';
import { ReactComponent as UpgradeIcon } from 'assets/icons/upgrade.svg'
import { ReactComponent as ProcessingIcon } from 'assets/icons/processing.svg'

// styles
import injectSheet from "react-jss";
import styles from './inprogress_styles';

/* ========== ~~~~~~~~~~ MIGRATION STATUS WIDGET : IN PROGRESS ~~~~~~~~~~ ========== */
const InProgress  = injectSheet(styles)((props) => {
  const dispatch = useDispatch();

  const activateMigration = () => {

  }

  return (
    <div className={`inprogress ${props.classes.inprogress}`}>
      <div className='info'>
        <span className='icon'><UpgradeIcon height={30} width={30} /></span>
        <p className='text'>Commenting 2.0 Migration Status</p>
      </div>
      <Button text={<span><ProcessingIcon /> In Progress</span>} handleClick={activateMigration} />
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default InProgress